import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { TaxExtensionProgressionActionsContainer } from '@/features/jobs/details/components/JobProgressionCard/TaxExtensionProgressionActions/TaxExtensionProgressionActionsContainer'
import { OpenItemsProgressionActions } from '@/features/jobs/details/components/JobProgressionCard/OpenItemsProgressionActions'

export interface OpenItemsProgressionActionsContainerProps {
  vm: JobProgressionViewModel
}

export const OpenItemsProgressionActionsContainer = observer(
  function OpenItemsProgressionActionsContainer({
    vm,
  }: OpenItemsProgressionActionsContainerProps) {
    return (
      <OpenItemsProgressionActions
        isAnyExtensionFlowAvailable={vm.isAnyExtensionFlowAvailable}
        onDocumentsReceived={vm.showJobStartedDialog}
        extensionActions={
          vm.isAnyExtensionFlowAvailable && (
            <TaxExtensionProgressionActionsContainer vm={vm} isSecondary />
          )
        }
      />
    )
  },
)
